<!--  -->
<template>
  <a @click="handleLink(linkData.name)">{{linkData.title}}</a>
</template>

<script>
export default {
  name: 'zlr-remind-link',
  props: ['data'],
  components: {},
  data () {
    return {
      linkData: {}
    }
  },
  computed: {},
  mounted () {
    this.messageMap()
  },
  methods: {
    handleLink (name) {
      if (!name) return false
      this.$emit('on-click')
      this.$router.push({
        name
      })
    },
    messageMap () {
      let type = this.data.type
      let data = {}
      switch (type) {
        case 'ACTIVE':
          data.title = '激活'
          break
        case 'TEAM':
          data = {
            title: '服务团队',
            name: 'team'
          }
          break
        case 'APPLY':
          data.title = '申请信息'
          break
        case 'CHANGEPWD':
          data.title = '修改密码'
          break
        case 'CV':
          data = {
            title: '简历',
            name: 'cv-rl'
          }
          break
        case 'RL':
          data = {
            title: '推荐信',
            name: 'cv-rl'
          }
          break
        case 'APPOINTMENT':
          data = {
            title: '导师辅导',
            name: 'mentor-application-record'
          }
          break
        case 'ESSAY':
        case 'PROJECT':
        case 'INTERVIEW_APPOINTMENT':
          data = {
            title: '项目申请',
            name: 'project-coach'
          }
          break
        case 'CONTACT_US':
          data = {
            title: '问题反馈',
            name: 'other-feedback'
          }
          break
        case 'CHOOSE_PROJECT':
          data = {
            title: '学校选择',
            name: 'project-choose-list'
          }
          break
      }
      this.linkData = data
    }
  },
  watch: {
    data () {
      this.messageMap()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
